




import Vue from "vue";
import Component from "vue-class-component";
import _ from "lodash";
import Auth from "front-component/Auth";
import Configuration from "front-component/Configuration";
import { Action, Getter } from "vuex-class";
import Owner from "@/model/cospirit-api/Owner";

@Component({})
export default class Token extends Vue {
    @Action("fetchCurrentUserData") public fetchCurrentUserData!: any;
    @Getter("getCurrentOwner") public getCurrentOwner!: Owner;

    private mounted() {
        const code = _.get(this.$router, "currentRoute.query.code", "");
        const isExternalSso = _.get(this.$router, "currentRoute.query.externalSso", "");
        if (isExternalSso && code) {
            Auth.setAccessToken(code);
            this.fetchCurrentUserData().then(() => {
                this.$router.push({path: Auth.getLastRoute()});
            });

            return;
        }

        Auth.ssoAuthenticate(Configuration.get("authUri"), Configuration.get("applicationId"), code)
            .then(() => {
                this.fetchCurrentUserData().then(() => {
                    this.$router.push({name: "redirect"});
                });
            })
            .catch((reason) => {
                this.$message({
                    type: "error",
                    message: _.invoke(this.$options.filters, "trans", "failedAuthentication"),
                });
                this.$router.push({name: "home"});
            });
    }
}
